import { useContext, useEffect, useRef, useState } from "react";
import { createGlobalStyle } from "styled-components";
import { UserContext } from "./components/UserContext";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useNavigate,
  Navigate,
} from "react-router-dom";
import { Callback } from "./components/Oauth2/Callback";
import Login from "./components/pages/Login";
import PageNotFound from "./components/pages/PageNotFound";
import Layout from "./components/reusable/Layout";
import Home from "./components/pages/Home";
import { BaseURL, productSlug } from "./components/BaseURL";
import toast from "react-hot-toast";
import "react-tippy/dist/tippy.css";
import OdPageNotFound from "./components/pages/OdPageNotFound";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { ProfileContent } from "./msal-login/ProfileContent";
import GetLocalStorageValue from "./components/reusable/GetLocalStorageValue";
import Button from "./components/reusable/Button";
import CnVersionNotAvailable from "./components/pages/CnVersionNotAvailable";
import ArticleNotAvailable from "./components/pages/ArticleNotAvailable";
import KbChooser from "./components/pages/KbChooser";

const GlobalStyle = createGlobalStyle`
body{
  background: ${({ darkTheme }) => (darkTheme ? "#262626" : "#eff3f8")};
  color: ${(props) => (props.darkTheme ? "#E5E0D8" : "#000000")};
}
`;

export default function MainWrapper() {
  const {
    darkTheme,
    setDarkTheme,
    setIsSearchOpen,
    allPosts,
    setAllPosts,
    setBodyData,
    bodyData,
    selectedHighlight,
    setSelectedHighlight,
    resToken,
    setResToken,
    loginDataLoading,
    codeNavigatorToken,
    tokenMode,
    setCodeNavigatorToken,
    setOpenMenu,
    setBreadCrumbCategory,
    setBreadCrumb,
    setUrlTagIdStore,
    setInitialLeftScrollTrue,
    leftScrollFlag,
    setLeftScrollFlag,
    setPostId,

    setIsOpenLink,
    setOdProduct,
    isOpenLink,
    isMsalLogin,
    setIsMsalLogin,
    setAllowFeedback,
    setCnUserInfo,
    cnUserInfo,
    versionName,
    setVersionName,
    isVersionNameClicked,
    versionNameInitialSlugSet,
    setVersionNameInitialSlugSet,
    // currentArticleAddrRefresh,
    setIsVersionNameClicked,
    product,
  } = useContext(UserContext);
  const [postLoader, setPostLoader] = useState(true);
  const [odLoader, setOdLoader] = useState(false);
  const [emptyPostLoader, setEmptyPostLoader] = useState(false);
  const [postLoaderHandler, setPostLoaderHandler] = useState(false);
  const [errMsgForPostLoaderHandler, setErrMsgForPostLoaderHandler] =
    useState(null);

  // Date: 15 March 2025
  const navigate = useNavigate();

  // Date: 28 Feb 2025
  let getCurrentArticleAddress = localStorage.getItem("currentArticleAddr");
  // useEffect(() => {
  //   getCurrentArticleAddress = localStorage.getItem("currentArticleAddr");
  // }, [currentArticleAddrRefresh]);
  // console.log("getCrr=>", getCurrentArticleAddress);

  // Date: 27 Feb 2025
  const [isArticleNotFound, setIsArticleNotFound] = useState(false);
  const [isOdArticleNotFound, setIsOdArticleNotFound] = useState(false);

  // 28 Jan 2025
  // Changes: Added codes for od link error handler.
  const [odPostLoaderHandler, setOdPostLoaderHandler] = useState(false);

  const [failedToFetchLoaderHandler, setFailedToFetchLoaderHandler] =
    useState(false);

  // Date: 15 Feb 2025
  // Ref: "As per Manigandan";
  // Changes: "Added new handler variable to handle article not matched show page";
  const [articleNotMatchedLoaderHandler, setArticleNotMatchedLoaderHandler] =
    useState(false);
  const [odFailedToFetchLoaderHandler, setoDFailedToFetchLoaderHandler] =
    useState(false);

  // const [isCNtoken, setIsCNtoken] = useState(false);

  // const navigate = useNavigate();
  // THEME toggle by SYSTEM
  const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
  useEffect(() => {
    const handleChange = (e) => {
      // setDarkTheme(mediaQuery.matches ? 'dark' : 'light');
      setDarkTheme(e.matches ? true : false);
    };

    // Listen for system theme changes
    mediaQuery.addEventListener("change", handleChange);

    return () => mediaQuery.removeEventListener("change", handleChange);
  }, [mediaQuery?.matches]);

  // ACCESS TOKEN
  const accessToken = localStorage.getItem("access_token");
  // CN ACCESS TOKEN
  const cnAccessToken = localStorage.getItem("cn_access_token");

  let gettingLocalStrVersionNameClickedId =
    localStorage.getItem("versionNameId");

  const hasMounted = useRef(false);

  const url = window.location.href;
  // const endPath = url.split("/").pop();
  // let codeNavigatorSlugLogin = url.includes("/auth?token=")
  let codeNavigatorSlugLogin = url.includes("/auth?token=")
    ? false
    : url.includes("token=")
      ? true
      : false;

  // Date: 21 Aug 2026
  // Ref: "Help & Documentation" from CN landed on Login instead of the docs
  // home page. Callback.js exchanges the CN token asynchronously and only
  // then sets tokenMode to "codenavigator" -- until it resolves, UserContext's
  // mount effect has already defaulted tokenMode to "personal" (no
  // cn_access_token in localStorage yet). The effect below reacts to that
  // transient "personal" value and calls getAllPostFunc() with a null
  // personal accessToken, which the backend correctly reports as
  // "Unauthenticated." -- and that handler resets codeNavigatorToken/resToken
  // to "", clobbering the real CN token Callback.js sets moments later. Skip
  // fetching while still on this callback route; Callback navigates away once
  // the exchange completes, re-triggering the effect with the real tokenMode.
  const isCnAuthCallback = url.includes("/auth?token=");

  if (url.includes("/auth?token=")) {
    localStorage.removeItem("cn_access_token");
  }

  // console.log("cnSlugLogin===>", codeNavigatorSlugLogin);

  // const cleanUrl = url.split("#")[0];
  // const endPath = cleanUrl.split("/").pop();
  // const tagIdUrl = url.split("#")[1] || "";   // 15 nov 2024

  // const endPath = url.split("/").pop();

  // const cleanUrl = url.split("#")[0];
  // const endPath = cleanUrl.split("/").pop();
  // const tagIdUrl = url.split("#")[1] || "";

  const cleanUrl = url.split("#")[0];
  // expressions for IDENTIFICATION
  const parsedUrl = new URL(cleanUrl);
  // Get the path and remove the leading "/"
  // const pathWithoutLeadingSlash = parsedUrl.pathname.slice(1);
  // const endPath1 = parsedUrl.pathname.slice(1);
  const endPath1 = parsedUrl.pathname.slice(1);
  // console.log("end-path-1==>", endPath1);
  // console.log("parsedUrl==>", parsedUrl);
  if (codeNavigatorSlugLogin) {
    localStorage.removeItem("cn_access_token");
    localStorage.removeItem("cn_rt");
    // setIsCNtoken(true)
    const slugByCN = endPath1;
    // const slugByCN = endPath1.slice(0, -5);
    localStorage.setItem("sByCN", slugByCN);

    // console.log("slugByCN===>", slugByCN);
  }
  if (tokenMode === "codenavigator") {
    const cnSlug = localStorage.getItem("sByCN");
    codeNavigatorSlugLogin = false;
    // setIsCNtoken(true)
    // localStorage.removeItem("sByCN");
  }
  // const endPath = codeNavigatorSlugLogin
  //   ? endPath1.slice(0, -5)
  //   : parsedUrl.pathname.slice(1);

  // const endPath =
  //   tokenMode === "codenavigator" || codeNavigatorSlugLogin
  //     ? codeNavigatorSlugLogin
  //       ? endPath1
  //       : localStorage.getItem("sByCN")
  //       ? localStorage.getItem("sByCN")
  //       : parsedUrl.pathname.slice(1)
  //     : parsedUrl.pathname.slice(1);
  // const tagIdUrl = url.split("#")[1] || ""; // 19 nov codes 2024
  const endPath2 =
    tokenMode === "codenavigator" || codeNavigatorSlugLogin
      ? codeNavigatorSlugLogin
        ? endPath1
        : localStorage.getItem("sByCN")
          ? localStorage.getItem("sByCN")
          : parsedUrl.pathname.slice(1)
      : parsedUrl.pathname.slice(1);
  const tagIdUrl = url.split("#")[1] || ""; // 15 Jan codes 2025

  // ------------------------Version-identify----------------------------------
  // Date: 15 Jan, 2025
  // Ref: Meeting for ask cn Versions control.
  // Changes: Added codes for verson switching.
  // Regular expression to match the version part (e.g., versionX.Y.Z)
  const [urlParamsVersionNameId, setUrlParamsVersionNameId] = useState(null);
  const gettingVersionNameByURLParams = async (v) => {
    const res = await fetch(
      `${BaseURL}/${tokenMode}/versions?product=${productSlug(product)}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${
            tokenMode === "personal" ? accessToken : cnAccessToken
          }`,
        },
      },
    );
    const data = await res.json();
    if (res.ok) {
      // const version = await data.data.find((item) => {
      //   if (item.slug === v) {
      //     return {
      //       value: item.id,
      //       name: item.name,
      //       slug: item.slug,
      //     };
      //   }
      // });
      const version = await data.data.find((item) => item.slug === v);
      // Date: 17 Jan, 2025
      // Ref: Meeting for ask cn Versions control.
      // Changes: Added codes for version switching.
      if (!versionName) {
        // localStorage.setItem("versionNameId", version?.id ? version.id : "");
        localStorage.setItem(
          "versionNameId",
          version?.slug ? version.slug : "",
        );
      }
      // Date: 11 Sep 2026
      // Ref: The URL's version segment can legitimately be absent from this
      // (now-filtered, active-versions-only) list -- e.g. an old bookmarked
      // link to a version that's since gone Inactive. Bail out instead of
      // crashing on version.slug; the personal/posts fetch below already has
      // its own "version/article not found" handling once urlParamsVersionNameId
      // stays unset.
      if (!version) {
        return;
      }
      await setVersionName(version.slug);
      // setUrlParamsVersionNameId(version.id);
      setUrlParamsVersionNameId(version.slug);
    }
  };
  // const versionRegex = /version(\d+\.\d+\.\d+)/;
  // const versionRegex = /^(\d+\.\d+\.\d+)/;

  // const versionRegex = /^\d{1,3}(\.\d{1,3}){1,3}$/;
  // const versionRegex = /^\d{1,3}(\.\d{1,3}){1,3}/;

  // Date: 24 Feb 2025
  // Date: 8 Aug 2026
  // Ref: A version created in admin with a hyphenated slug (e.g. "1-0-0", see
  // VersionController@buildVersionSlug which allows both "." and "-") never
  // matched this dot-only regex, so on refresh the version segment was never
  // stripped out of the URL and got appended to the slug lookup, always
  // missing and tripping "Article not found". Accept "-" as a separator too.
  const versionRegex = /\b\d{1,3}([.-]\d{1,3}){1,3}\b/; // best math[0] not match[1]

  const versionMatch = endPath2.match(versionRegex);
  let version = null;
  // if (versionMatch) {
  //   version = versionMatch[1]; // Extract '2.0.0' from 'version2.0.0'
  //   // setVersionName(2);
  //   gettingVersionNameByURLParams(version);
  //   console.log("versisss==>", version);
  // }

  // Remove the version part from the URL
  // const cleanedUrl = endPath2.replace(versionRegex, '').replace(/^\/|\/$/g, '');
  // Date: 8 Aug 2026
  // Ref: Refreshing an article under "/cloudframe/codenavigator/<version>/<slug>"
  // showed "Article not found". Removing the version segment (e.g. "2.0.0") from
  // the middle of the path leaves a double slash ("codenavigator//slug"); the old
  // ^\/|\/$ trim only strips a slash at the very start/end of the string, so once
  // a route prefix sits in front of the version segment, that double slash is no
  // longer at position 0 and survives. Collapsing repeated slashes first keeps
  // the trim (and the prefix strip below) working regardless of prefix.
  const rawEndPath = endPath2
    .replace(versionRegex, "")
    .replace(/\/{2,}/g, "/")
    .replace(/^\/|\/$/g, "");
  // Date: 7 Aug 2026
  // Ref: Continuum KB rollout. KbChooser.js sends users to a per-product launch
  // URL (see options[].path there), and codeNavigator's content routes are now
  // mounted under that same "/cloudframe/codenavigator" prefix (see the Routes
  // below) so Home's internal navigate() calls don't drop it. Strip the prefix
  // here before slug-matching below, since it's a route prefix, not part of the
  // post slug itself -- otherwise the launch prefix never matches a real post's
  // slug and trips the "Article not found" handler.
  // Date: 8 Aug 2026
  // Ref: Refreshing the bare KbChooser route ("/cloudframe", shown while
  // tokenMode === "personal" && !product -- see the Routes below) also tripped
  // "Article not found": "cloudframe" itself isn't a post slug, but it wasn't in
  // this list either, so it fell through unstripped and got looked up as one.
  // Included here too, sorted longest-first so it doesn't shadow the more
  // specific "cloudframe/codenavigator" / "cloudframe/continuum" prefixes.
  const productLaunchPrefixes = [
    "cloudframe/codenavigator",
    "cloudframe/continuum",
    "cloudframe",
  ].sort((a, b) => b.length - a.length);
  const matchedLaunchPrefix = productLaunchPrefixes.find(
    (prefix) => rawEndPath === prefix || rawEndPath.startsWith(`${prefix}/`),
  );
  const endPath = matchedLaunchPrefix
    ? rawEndPath.slice(matchedLaunchPrefix.length).replace(/^\/+/, "")
    : rawEndPath;
  // console.log("end-path==>", endPath);
  // ----------------------------------------------------------

  // Date: 11 Sep 2026
  // Ref: An MSAL redirect login lands back on this app's own URL with the
  // OAuth response in the hash (e.g. "#code=...&client_info=...&state=...
  // &session_state=..."), which this same "#<id>" parsing otherwise mistakes
  // for a heading-anchor id and stores -- later crashing Home.js's
  // querySelector(`#${urlTagIdStore}`) since it isn't valid selector syntax.
  // A real heading anchor id never contains "=", so use that to tell the two
  // apart at the source instead of only guarding the eventual querySelector.
  if (tagIdUrl && !tagIdUrl.includes("=")) {
    setUrlTagIdStore(tagIdUrl);
  }

  const cnAccessPath = new URLSearchParams(window.location.search);
  const queryByCN = cnAccessPath.get("token");

  // Date: 09 Jan 2026 ---start
  const gettingRefreshFuncWhenSlugNull = () => {
    localStorage.removeItem("cn_access_token");

    // Date: 09 Jan 2026
    localStorage.removeItem("versionNameId");
    localStorage.removeItem("currentArticleAddr");
    localStorage.removeItem("currentUrl");
    localStorage.removeItem("previousUrl");
    localStorage.removeItem("odVersion");

    return (window.location.href = "/");
  };
  // Date: 09 Jan 2026 ---end

  // GETTING ALL POST
  const getAllPostFunc = async () => {
    // Date: 21 Aug 2026
    // Ref: "Help & Documentation" from CN still landed on Login with the
    // request Authorization header literally "Bearer null" -- this function
    // used to unconditionally wipe resToken/codeNavigatorToken to "" below
    // *before* even checking whether the current mode has a real token to
    // fetch with, then fired /personal or /codenavigator posts regardless.
    // If this fires while tokenMode is transiently "personal" with no
    // accessToken yet (e.g. mid CN-token exchange), it (a) sends a
    // guaranteed-401 request with "Bearer null" and (b) wipes out a real
    // codeNavigatorToken that Callback.js may have just set. /od links never
    // need a token (no Authorization header sent below), so only guard the
    // personal/codenavigator path.
    if (!url.includes("/od")) {
      const resolvedToken = tokenMode === "personal" ? accessToken : cnAccessToken;
      if (!resolvedToken) {
        setPostLoader(false);
        return;
      }
    }

    setPostLoader(true);
    setResToken("");
    setCodeNavigatorToken("");

    if (url.includes("/od")) {
      // my Error Handling failed to fetch start
      try {
        //Date: 7 Feb 2025
        //Ref: Working on as per Manigandan, (Production site) in od(open document) by OD link, user see only one article that we will share the article links to users. That is added to identify specific article.
        // Changes: Added new Codes.

        // const gettingPostSlugByod = endPath.replace("od/", ""); // worked pefectly.
        let gettingPostSlugByod = "";
        gettingPostSlugByod = endPath.includes("od//")
          ? endPath.replace("od//", "")
          : endPath.replace("od/", "");

        // console.log("--->kpk->", {
        //   gettingPostSlugByod,
        //   endPath,
        //   linkk: `${BaseURL}/od/posts${gettingPostSlugByod}`,
        // });

        // Date: 01 Oct 2026
        // Ref: Shared OD links are now "/od/<version>/<slug>" so the backend only
        // serves the article from that exact version (a different version, or
        // the same article with Open Document unchecked, must be blocked).
        // endPath has already had the version segment stripped out above, so
        // read it straight from the URL; bare "/od/<slug>" links shared before
        // this change still go through the version-less endpoint.
        const odPathSegments = parsedUrl.pathname
          .split("/")
          .filter(Boolean);
        const odVersionSlug =
          odPathSegments[0] === "od" && odPathSegments.length >= 3
            ? odPathSegments[1]
            : null;
        // Home/Layout rewrite the URL to `${isOpenLink}/${slug}` once the
        // article loads, so carry the version in the prefix or it's dropped
        // from the address bar (and a refresh falls back to the old lookup).
        setIsOpenLink(odVersionSlug ? `od/${odVersionSlug}` : "od");
        // endPath's version strip only recognises numeric slugs ("5.4.0",
        // "1-0-0"), but admin also allows slugs like "v5.4" or "beta", so take
        // the article slug from the last path segment for versioned links.
        if (odVersionSlug) {
          gettingPostSlugByod = odPathSegments[odPathSegments.length - 1];
        }
        const odPostsUrl = odVersionSlug
          ? `${BaseURL}/od/posts/${encodeURIComponent(odVersionSlug)}/${gettingPostSlugByod}`
          : `${BaseURL}/od/posts/${gettingPostSlugByod}`;

        // OPEN LINK FETCHING
        const res = await fetch(odPostsUrl, {
          // const res = await fetch(`${BaseURL}/od/posts${gettingPostSlugByod}`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            // Authorization: `Bearer ${
            //   tokenMode === "personal" ? accessToken : cnAccessToken
            // }`,
          },
        });
        const data = await res.json();

        if (data?.success) {
          setPostLoader(true);
          setOdProduct(
            data?.product === "continuum" ? "continuum" : "codeNavigator",
          );

          // await setAllPosts(data.data);
          // COUNTS hEADING using DOMparser
          const parseHTMLAndCountHeadings = (dataArray) => {
            return dataArray.map((user) => {
              // Map through each user's posts
              const updatedPosts = user.posts.map((post) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(post.body, "text/html");

                // Count all headings h1, h2, h3, and h4
                const count = {
                  h1: doc.getElementsByTagName("h1").length,
                  // h2: doc.getElementsByTagName("h2").length,
                  // h3: doc.getElementsByTagName("h3").length,
                  // h4: doc.getElementsByTagName("h4").length,
                };

                // Return a new post object with the count key added
                return {
                  ...post,
                  count,
                };
              });

              // Return a new user object with the updated posts
              return {
                ...user,
                posts: updatedPosts,
              };
            });
          };

          const newUpdatedData = await parseHTMLAndCountHeadings(data?.data);
          await setAllPosts(newUpdatedData);

          // console.log("new", newUpdatedData);
          // console.log("old", allPosts);
          // END HEADING COUNTS

          const updatedData = await data.data.map((item) => {
            return {
              ...item,
              posts: item.posts.map((post) => ({
                ...post,
                name: item.name,
              })),
            };
          });
          // console.log("myAllPoost", updatedData)
          const myAllPosts = await updatedData.flatMap(
            (category) => category.posts,
          );
          if (endPath !== ("od" || "od/") && !queryByCN) {
            // console.log("locaddd--->--->kpk=>", endPath);
            setPostLoader(true);
            // setAllPosts(data.data);
            // const myAllPosts = await data.data.flatMap(
            //   (category) => category.posts
            // );

            // const slugByod = endPath.replace("od/", ""); worked perfectly.
            let slugByod = "";
            slugByod = endPath.replace("od//", "");
            slugByod = endPath.replace("od/", "");
            if (odVersionSlug) {
              slugByod = gettingPostSlugByod;
            }

            const filtered = await myAllPosts.filter(
              // (post) => post.slug === endPath
              (post) => post.slug === slugByod,
            );

            if (filtered.length > 0) {
              setPostLoader(true);
              // setInitialLeftScrollTrue(true)
              await setBodyData(filtered[0].body);
              await setSelectedHighlight(filtered[0].slug);
              await setBreadCrumbCategory(filtered[0].name);
              await setBreadCrumb(filtered[0].title);
              await setPostId(filtered[0].id);
              // await setOpenMenu(0);
              await setResToken(accessToken || "");
              await setCodeNavigatorToken(cnAccessToken || "");

              setPostLoader(false);
              // setInitialLeftScrollTrue(false)
              setInitialLeftScrollTrue(true);
              setLeftScrollFlag(true);
              return;
            } else {
              // toast.error("Wrong address, Go to home address");

              // Date: 8 Feb 2025
              // Ref: Self analyse the optimization and improvements of user experience.
              // Changes: "Update error information"
              // toast.error("Article not found. Go back to the Home Page");
              toast.error("Article not found");
              // navigate("/od/page-not-found");
              // setTimeout(() => {
              //   window.location.href = "/od";
              // }, 1000);

              // Date: 27 Feb 2025
              setPostLoader(false);
              setIsOdArticleNotFound(true);
            }
          } else {
            if (myAllPosts.length > 0) {
              setPostLoader(true);
              // setInitialLeftScrollTrue(true)

              // setAllPosts(data.data);

              // await setBodyData(data.data[0].posts[0].body);
              // await setSelectedHighlight(data.data[0].posts[0].slug);
              // await setBreadCrumbCategory(data.data[0].posts[0].name);
              // await setBreadCrumb(data.data[0].posts[0].title);

              await setSelectedHighlight(myAllPosts[0].slug);
              await setBodyData(myAllPosts[0].body);
              await setBreadCrumbCategory(myAllPosts[0].name);
              await setBreadCrumb(myAllPosts[0].title);
              await setPostId(myAllPosts[0].id);

              // await setOpenMenu(0);
              await setResToken(accessToken || "");
              await setCodeNavigatorToken(cnAccessToken || "");

              setPostLoader(false);
              // setInitialLeftScrollTrue(false)
              setInitialLeftScrollTrue(true);
              setLeftScrollFlag(true);
            } else {
              // toast.error("Data not available in the selected version.");

              // Date: 20 Jan, 2025
              // Ref: MySelf.
              // Changes: Improve Error Handling.
              setPostLoader(false);
              setOdLoader(true);
            }
          }
        } else if (data?.message === "Unauthenticated.") {
          setPostLoader(true);

          setAllPosts([]);
          setResToken("");
          setCodeNavigatorToken("");
          setPostLoader(false);
          setInitialLeftScrollTrue(false);
        } else if (res.status === 404) {
          // Date: 01 Oct 2026
          // Not an Open Document in that version (or no such version/article):
          // show "Article not found" rather than the generic "Internal error".
          setAllPosts([]);
          setPostLoader(false);
          setIsOdArticleNotFound(true);
        } else {
          setPostLoader(true); //important
          setInitialLeftScrollTrue(false);

          setAllPosts([]);
          // toast.error("Unauthorized User !");
          setResToken("");
          setCodeNavigatorToken("");
          // setPostLoader(false);

          // IN OD INTERNAL 500 ERROR
          // toast.error("Wrong address OR There is no internet connection");

          // Date: 28 Jan 2025
          setPostLoader(false);
          setOdPostLoaderHandler(true);
        }
        if (bodyData) {
          setInitialLeftScrollTrue(false);
          setLeftScrollFlag(false);
        } else {
          setInitialLeftScrollTrue(false);
          setLeftScrollFlag(false);
        }
      } catch (err) {
        if (err.message === "Failed to fetch") {
          // toast.error(
          //   "Network error: Unable to fetch data. Please check your connection."
          // );
          setPostLoader(false);
          setoDFailedToFetchLoaderHandler(true);
        }
        // else{
        //   toast.error(`An error occurred: ${err.message}`)
        // }
      } finally {
        const timerOutLoader = setTimeout(() => {
          setPostLoader(false);
        }, 2000);
        return () => clearTimeout(timerOutLoader);
      }
      // my Error Handling failed to fetch end
    } else {
      try {
        //  my ORIGINAL LOGIN start

        // Date: 15 Jan, 2025
        // Ref: Meeting for ask cn Versions control.
        // Changes: Added queryParams codes for version switching.

        // Date: 17 Jan, 2025
        // Ref: Meeting for ask cn Versions control.
        // Changes: Added codes for version switching.
        gettingLocalStrVersionNameClickedId =
          localStorage.getItem("versionNameId");

        // Date: 24 Feb 2025,  version testing
        // console.log("version-regex", versionRegex)
        // console.log("version-match", versionMatch)
        // return alert("hiiii")

        if (versionMatch) {
          // version = versionMatch[1]; // Extract '2.0.0' from 'version2.0.0'
          version = versionMatch[0];
          // console.log("version-match", version);
          // return alert("hiiii");

          // setVersionName(2);
          await gettingVersionNameByURLParams(version);

          // 8 Jan 2025
          // Ref: Observe to improve routes.
          // Changes: "If we pase defferent article and version and that is available, but we are in different version then it will switch target version"
          gettingLocalStrVersionNameClickedId =
            localStorage.getItem("versionNameId");
        }
        // Data to send
        // const versionData = {
        //   version: versionName?.value
        //     // ? versionName.value
        //     // : versionName?.id
        //     // ? versionName.id
        //     // : "",
        // };

        const versionData = {
          version: gettingLocalStrVersionNameClickedId
            ? gettingLocalStrVersionNameClickedId
            : urlParamsVersionNameId
              ? urlParamsVersionNameId
              : "",
          product: productSlug(product),
        };
        // Convert the data to query string
        const queryParams = new URLSearchParams(versionData).toString();
        // const versionValidate = queryParams?.version !== "" ? queryParams : "";
        const versionValidate = queryParams ? queryParams : "";
        // const versionValidate = queryParams;
        // WITH CREDENTIALS

        // Date: 15 March 2025 ----holi---------start
        // if (endPath2 === "version_not_available_with_cn") {
        //   toast.error("ok fine");
        //   setPostLoader(false);
        //   navigate("/version_not_available_with_cn");
        //   return;
        // }
        // Date: 15 March 2025 -------------end

        const res = await fetch(
          `${BaseURL}/${tokenMode}/posts?${versionValidate}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${
                tokenMode === "personal" ? accessToken : cnAccessToken
              }`,
            },
          },
        );
        const data = await res.json();

        if (data?.success) {
          setPostLoader(true);

          // SET-VERSION SELECT
          // setVersionName(data?.version?.id);
          const versionSlug = data?.version?.slug ? data.version.slug : "";
          setVersionName(versionSlug);
          setVersionNameInitialSlugSet(versionSlug);
          // localStorage.setItem(
          //   "versionNameId",
          //   data?.version?.id ? data.version.id : ""
          // );

          // await setAllPosts(data.data);
          // COUNTS hEADING using DOMparser
          const parseHTMLAndCountHeadings = (dataArray) => {
            return dataArray.map((user) => {
              // Map through each user's posts
              const updatedPosts = user.posts.map((post) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(post.body, "text/html");

                // Count all headings h1, h2, h3, and h4
                const count = {
                  h1: doc.getElementsByTagName("h1").length,
                  // h2: doc.getElementsByTagName("h2").length,
                  // h3: doc.getElementsByTagName("h3").length,
                  // h4: doc.getElementsByTagName("h4").length,
                };

                // Return a new post object with the count key added
                return {
                  ...post,
                  count,
                };
              });

              // Return a new user object with the updated posts
              return {
                ...user,
                posts: updatedPosts,
              };
            });
          };

          const newUpdatedData = await parseHTMLAndCountHeadings(data?.data);
          await setAllPosts(newUpdatedData);

          // console.log("new", newUpdatedData);
          // console.log("old", allPosts);
          // END HEADING COUNTS

          const updatedData = await data.data.map((item) => {
            return {
              ...item,
              posts: item.posts.map((post) => ({
                ...post,
                name: item.name,
              })),
            };
          });
          // console.log("myAllPoost", updatedData)
          const myAllPosts = await updatedData.flatMap(
            (category) => category.posts,
          );
          if (endPath && !queryByCN) {
            // if (endPath) {
            setPostLoader(true);
            // setAllPosts(data.data);
            // const myAllPosts = await data.data.flatMap(
            //   (category) => category.posts
            // );

            const filtered = await myAllPosts.filter(
              (post) => post.slug === endPath,
            );

            if (filtered.length > 0) {
              setPostLoader(true);
              // setInitialLeftScrollTrue(true)

              localStorage.removeItem("sByCN");

              await setBodyData(filtered[0].body);
              await setSelectedHighlight(filtered[0].slug);
              await setBreadCrumbCategory(filtered[0].name);
              await setBreadCrumb(filtered[0].title);
              await setPostId(filtered[0].id);
              await setAllowFeedback(filtered[0].post_feedbacks_count);
              // await setOpenMenu(0);
              await setResToken(accessToken || "");
              await setCodeNavigatorToken(cnAccessToken || "");

              setPostLoader(false);
              // setInitialLeftScrollTrue(false)
              setInitialLeftScrollTrue(true);
              setLeftScrollFlag(true);
            } else if (myAllPosts.length > 0) {
              // Date: 8 Sep 2026
              // Ref: Continuum only ever hits this (non-queryByCN) branch --
              // it has no embedded-token flow -- so switching to a version
              // that doesn't carry this article slug (renamed/removed) fell
              // through to "Article not found" here, while CodeNavigator's
              // queryByCN branch below already falls back to the version's
              // first article in the same situation. Mirror that fallback
              // here instead of erroring out on a successful version switch.
              setPostLoader(true);

              localStorage.removeItem("sByCN");

              await setSelectedHighlight(myAllPosts[0].slug);
              await setBodyData(myAllPosts[0].body);
              await setBreadCrumbCategory(myAllPosts[0].name);
              await setBreadCrumb(myAllPosts[0].title);
              await setPostId(myAllPosts[0].id);
              await setAllowFeedback(myAllPosts[0].post_feedbacks_count);
              await setResToken(accessToken || "");
              await setCodeNavigatorToken(cnAccessToken || "");

              setPostLoader(false);
              setInitialLeftScrollTrue(true);
              setLeftScrollFlag(true);
            } else {
              // toast.error("Wrong address, Go to home address");
              // localStorage.removeItem("versionNameId");
              localStorage.removeItem("sByCN");
              // toast.error("Article not found. Going back to the Home Page");
              // setTimeout(() => {
              //   window.location.href = "/";
              // }, 1000);

              // Date: 27 Feb 2025
              setPostLoader(false);
              setIsArticleNotFound(true);
              // window.location.href = "/article-not-available";
            }
          } else if (endPath && queryByCN) {
            setPostLoader(true);
            // setAllPosts(data.data);
            // const myAllPosts = await data.data.flatMap(
            //   (category) => category.posts
            // );

            const filtered = await myAllPosts.filter(
              (post) => post.slug === endPath,
            );

            if (filtered.length > 0) {
              setPostLoader(true);
              // setInitialLeftScrollTrue(true)

              localStorage.removeItem("sByCN");

              await setBodyData(filtered[0].body);
              await setSelectedHighlight(filtered[0].slug);
              await setBreadCrumbCategory(filtered[0].name);
              await setBreadCrumb(filtered[0].title);
              await setPostId(filtered[0].id);
              await setAllowFeedback(filtered[0].post_feedbacks_count);
              // await setOpenMenu(0);
              await setResToken(accessToken || "");
              await setCodeNavigatorToken(cnAccessToken || "");

              setPostLoader(false);
              // setInitialLeftScrollTrue(false)
              setInitialLeftScrollTrue(true);
              setLeftScrollFlag(true);
            }
            // else {
            //   // toast.error("Wrong address, Go to home address");
            //   toast.error("Oops! Incorrect Address. Go back to the Home Page");
            // }
            else {
              setPostLoader(true);
              // setInitialLeftScrollTrue(true)

              localStorage.removeItem("sByCN");

              // setAllPosts(data.data);

              // await setBodyData(data.data[0].posts[0].body);
              // await setSelectedHighlight(data.data[0].posts[0].slug);
              // await setBreadCrumbCategory(data.data[0].posts[0].name);
              // await setBreadCrumb(data.data[0].posts[0].title);

              await setSelectedHighlight(myAllPosts[0].slug);
              await setBodyData(myAllPosts[0].body);
              await setBreadCrumbCategory(myAllPosts[0].name);
              await setBreadCrumb(myAllPosts[0].title);
              await setPostId(myAllPosts[0].id);
              await setAllowFeedback(myAllPosts[0].post_feedbacks_count);

              // await setOpenMenu(0);
              await setResToken(accessToken || "");
              await setCodeNavigatorToken(cnAccessToken || "");

              setPostLoader(false);
              // setInitialLeftScrollTrue(false)
              setInitialLeftScrollTrue(true);
              setLeftScrollFlag(true);
            }
          } else {
            if (myAllPosts.length > 0) {
              setPostLoader(true);
              // setInitialLeftScrollTrue(true)

              localStorage.removeItem("sByCN");

              // setAllPosts(data.data);

              // await setBodyData(data.data[0].posts[0].body);
              // await setSelectedHighlight(data.data[0].posts[0].slug);
              // await setBreadCrumbCategory(data.data[0].posts[0].name);
              // await setBreadCrumb(data.data[0].posts[0].title);

              await setSelectedHighlight(myAllPosts[0].slug);
              await setBodyData(myAllPosts[0].body);
              await setBreadCrumbCategory(myAllPosts[0].name);
              await setBreadCrumb(myAllPosts[0].title);
              await setPostId(myAllPosts[0].id);
              await setAllowFeedback(myAllPosts[0].post_feedbacks_count);

              // await setOpenMenu(0);
              await setResToken(accessToken || "");
              await setCodeNavigatorToken(cnAccessToken || "");

              setPostLoader(false);
              // setInitialLeftScrollTrue(false)
              setInitialLeftScrollTrue(true);
              setLeftScrollFlag(true);
            } else {
              localStorage.removeItem("sByCN");
              localStorage.setItem("versionNameId", "");
              // toast.error(
              //   "Oops! Incorrect Address. Going back to the Home Page"
              // );
              // setTimeout(() => {
              //   window.location.href = "/";
              // }, 700);

              // Date: 20 Jan, 2025
              // Ref: MySelf.
              // Changes: Improve Error Handling.
              // toast.error("Data not available in the selected version.");
              setPostLoader(false);
              setEmptyPostLoader(true);
            }
          }
        } else if (data?.message === "Unauthenticated.") {
          setPostLoader(true);

          setAllPosts([]);
          setResToken("");
          setCodeNavigatorToken("");
          setPostLoader(false);
          setInitialLeftScrollTrue(false);
        } else {
          // setPostLoader(true); //important
          setInitialLeftScrollTrue(false);

          setAllPosts([]);
          // toast.error("Unauthorized User !");
          setResToken("");
          setCodeNavigatorToken("");
          // setPostLoader(false);

          // toast.error("Internal error");

          // Date: 20 Jan 2025
          setPostLoader(false);
          // setPostLoaderHandler(true); // imp before 09 Jan 2026

          if (data?.message) {
            // Date: 09 Jan 2026----start
            return gettingRefreshFuncWhenSlugNull();
            // Date: 09 Jan 2026----end

            const errMsg = data?.message ? data.message : "Somthing went wrong";
            setErrMsgForPostLoaderHandler(errMsg); // imp before 09 Jan 2026
            toast.error(errMsg); // Date: 17 March 2025
          }
        }
        if (bodyData) {
          setInitialLeftScrollTrue(false);
          setLeftScrollFlag(false);
        } else {
          setInitialLeftScrollTrue(false);
          setLeftScrollFlag(false);
        }

        //  my ORIGINAL LOGIN end
      } catch (err) {
        if (err.message === "Failed to fetch") {
          // toast.error(
          //   "Network error: Unable to fetch data. Please check your connection."
          // );
          setPostLoader(false);
          setFailedToFetchLoaderHandler(true);
        }
        // else{
        //   toast.error(`An error occurred: ${err.message}`)
        // }
        else if (
          err.message === "Cannot read properties of undefined (reading 'slug')"
        ) {
          // toast.error(`An error occurred: ${err.message}`);
          setPostLoader(false);
          setArticleNotMatchedLoaderHandler(true);
        } else {
          toast.error(`An error occurred: ${err.message}`);
          setPostLoader(false);
          setFailedToFetchLoaderHandler(true);
        }
      }
    }
  };

  // useEffect(() => {
  //   if (!hasMounted.current) {
  //     hasMounted.current = true;
  //     return;
  //   }

  //   getAllPostFunc();
  // }, [codeNavigatorToken || resToken]);

  const prevProductRef = useRef(product);
  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      prevProductRef.current = product;
      return;
    }

    // Date: 8 Aug 2026
    // Ref: Continuum KB rollout. `product` only changes which route renders
    // (see the Routes below) -- it doesn't remount MainWrapper -- so without
    // `product` in this effect's deps, switching CodeNavigator <-> Continuum
    // never re-fetched; the page kept showing whichever product's posts were
    // fetched first (allPosts/bodyData are stale), just rendered under the
    // newly-active product's route shell.
    // versionNameId (localStorage) and versionName also aren't namespaced by
    // product, so a version slug pinned under the previous product would
    // otherwise carry over -- it may not exist for the new product (404
    // "Version not available"), or worse, coincidentally match a same-named
    // version belonging to the other product. Clear it first, synchronously,
    // whenever product actually changed, so getAllPostFunc below reads a
    // clean slate and falls back to the new product's own latest version.
    if (product !== prevProductRef.current) {
      prevProductRef.current = product;
      localStorage.removeItem("versionNameId");
      setVersionName("");
      setVersionNameInitialSlugSet("");
      setUrlParamsVersionNameId(null);

      // Date: 10 Sep 2026
      // Ref: "Dashboard -> product -> back -> product again" white-screens.
      // bodyData/allPosts were never cleared on a product switch, only
      // overwritten once getAllPostFunc's fetch resolved -- so Home/MiddleHome
      // remount under the new product's route (see the Routes below) still
      // holding the *previous* product's fully-populated article HTML/headings
      // for a render or two. Home's DOM-manipulation effects assume that data
      // shape matches the currently-mounted product and aren't all null-safe;
      // fed mismatched stale content they can throw, and with no ErrorBoundary
      // in the tree (see index.js) that takes down the whole app. Clear them
      // synchronously here so the remount starts from an empty, safe state
      // instead of stale content from the other product.
      setBodyData({});
      setAllPosts([]);
      setSelectedHighlight("");
    }

    // Date: 11 Aug 2026
    // Ref: Continuum KB rollout follow-up. A personal-login user with no
    // product chosen yet lands on KbChooser (see the Routes below), but this
    // effect used to call getAllPostFunc() anyway, fetching posts for the
    // default product ("code-navigator") before the user ever picks one. For
    // a user with access to neither product that fetch 403s, and
    // getAllPostFunc's catch-all branch hard-redirects to "/" -- which
    // remounts everything and repeats the same fetch, looping forever behind
    // the loading splash. Skip the fetch while the chooser is pending; it
    // re-fires once `product` is set (chooseProduct navigates, which updates
    // this effect's `product` dep). setPostLoader(false) is still needed here
    // so the loading splash clears and the chooser actually renders.
    const chooserPending = tokenMode === "personal" && !product;

    if (isCnAuthCallback) {
      // Callback.js is still exchanging the CN token; don't fetch on the
      // transient "personal" tokenMode default (see note above `url`).
      // setPostLoader(false) is required here -- postLoader starts true, and
      // the render below gates on `postLoader || loginDataLoading` *before*
      // <Routes> (and so <Callback/>) ever mounts. Skipping the fetch without
      // also clearing postLoader left that gate stuck open forever, so
      // Callback's own token-exchange effect never got a chance to run at
      // all -- an infinite spinner with zero network activity.
      setPostLoader(false);
      return;
    }

    // Date: 01 Oct 2026
    // Ref: Logged-out visitors opening a shared "/od/..." link got "Your
    // session has expired". isOpenLink is only set inside getAllPostFunc, but
    // with no product chosen yet chooserPending skipped that call, so the OD
    // fetch never started. Check the URL itself instead (exact "od" first
    // segment, so slugs like "odata-..." don't count).
    const isOdUrl = parsedUrl.pathname.split("/").filter(Boolean)[0] === "od";

    if (isOpenLink || isOdUrl) {
      getAllPostFunc();
    } else if (chooserPending) {
      setPostLoader(false);
    } else if (tokenMode || codeNavigatorToken) {
      getAllPostFunc();
    }
  }, [tokenMode, isOpenLink, product]);

  // Date: 1 March 2025
  // Date: 12 Aug 2026
  // Ref: "Switching to a version with the same article doesn't redirect at
  // all" bug report. `versionName` is set as a plain slug string everywhere
  // (see setVersionName calls above), never an object -- so `versionName.slug`
  // was always undefined and this effect's getAllPostFunc() never ran.
  useEffect(() => {
    if (versionName && isVersionNameClicked) {
      getAllPostFunc();
      // Date: 1 March 2025
      setIsVersionNameClicked(false);
    }
  }, [isVersionNameClicked]);

  // GETTING CN_ACCESS TOKEN FROM REFRESH TOKEN
  useEffect(() => {
    if (allPosts.length > 0) {
      // TOKEN EXPIRATION TIME day | year | HOURS
      const personalVerify = async () => {
        const res = await fetch(`${BaseURL}/${tokenMode}/verify`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${
              tokenMode === "personal" ? accessToken : cnAccessToken
            }`,
          },
        });
        const resData = await res.json();
        const msg = resData?.message;
        if (msg === "Unauthenticated.") {
          const getCNaccessTokenFromRefreshToken = async () => {
            const rToken = sessionStorage.getItem("cn_rtoken");
            const res = await fetch(
              `${BaseURL}/get-accesstoken-from-refreshtoken`,
              {
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
                method: "POST",
                body: JSON.stringify({ refresh_token: rToken }),
                // body: "",
                // credentials: "include",
              },
            );

            const data = await res.json();

            if (data?.access_token) {
              if (localStorage.getItem("cn_access_token")) {
                localStorage.setItem("cn_access_token", data.access_token);
              } else if (localStorage.getItem("access_token")) {
                localStorage.setItem("access_token", data.access_token);
              }
              sessionStorage.setItem("cn_rtoken", data.refresh_token);
              setCodeNavigatorToken(data.access_token);
              // setCodeNavigatorToken("");
              // setResToken("");

              // Date: 12 Dec, 2024
              // Ref: Email/Meeting on 11 Dec, 2024 from Manigandan to add cn Username and version.
              // Changes: Storing cn Username and version.
              if (data?.customer_name || data?.platform_version) {
                const userInfoFromCN = {
                  customer_name: data.customer_name || "",
                  platform_version: data.platform_version || "",
                  license_type: data.license_type || "",
                };
                localStorage.setItem(
                  "cn_userInfo",
                  JSON.stringify(userInfoFromCN),
                );
                const gettingCnUserInfoData = await GetLocalStorageValue(
                  "cn_userInfo",
                  {},
                );
                setCnUserInfo(gettingCnUserInfoData);
                // setCnUserInfo(userInfoFromCN);
              } else {
                localStorage.removeItem("cn_userInfo");
              }
            }
          };
          getCNaccessTokenFromRefreshToken();
        }
      };
      const interval = setInterval(() => {
        // if (!isOpenLink) {
        personalVerify();
        // }
      }, 120000);
      return () => clearInterval(interval);
    }
    // }, [(accessToken && resToken) || (cnAccessToken && codeNavigatorToken)])
  }, [allPosts.length > 0]);

  // useEffect(() => {
  //   if (allPosts.length > 0) {
  //     // TOKEN EXPIRATION TIME day | year | HOURS
  //     const personalVerify = async () => {
  //       const res = await fetch(`${BaseURL}/${tokenMode}/verify`, {
  //         method: "GET",
  //         headers: {
  //           Accept: "application/json",
  //           Authorization: `Bearer ${
  //             tokenMode === "personal" ? accessToken : cnAccessToken
  //           }`,
  //         },
  //       });
  //       const resData = await res.json();
  //       const msg = resData?.message;
  //       if (msg === "Unauthenticated.") {
  //         localStorage.removeItem("access_token");
  //         localStorage.removeItem("cn_access_token");
  //         setAllPosts([]);
  //         setResToken("");
  //         setCodeNavigatorToken("");
  //         toast.error("Session has been expired !");

  //         const goingLoginFunc = () => {
  //           setResToken("");
  //           setCodeNavigatorToken("");
  //           localStorage.removeItem("access_token");
  //           localStorage.removeItem("cn_access_token");
  //           window.location.reload();
  //         };
  //         return (
  //           <div className="flex items-center justify-center flex-col h-screen px-3 gap-y-4">
  //             {/* <div className={`text-lg`}>404</div> */}
  //             <div className="{`text-lg`}">Session has been expired.</div>
  //             <button
  //               type="submit"
  //               className={`px-11 py-2 rounded-full bg-lighGray text-Black flex items-center gap-1 flex-wrap transition-all font-medium font-Barlow_medium hover:bg-White active:bg-opacity-60`}
  //               onClick={(e) => goingLoginFunc(e)}
  //             >
  //               Go to Login Page
  //             </button>
  //           </div>
  //         );
  //       }
  //     };
  //     const interval = setInterval(() => {
  //       if (!isOpenLink) {
  //         personalVerify();
  //       }
  //     }, 120000);
  //     return () => clearInterval(interval);
  //   }
  //   // }, [(accessToken && resToken) || (cnAccessToken && codeNavigatorToken)])
  // }, [allPosts.length > 0]);

  // console.log("allPosts", allPosts);

  // useEffect(() => {
  //   const myAllPosts = allPosts.flatMap(user => user.posts);
  //   const filtered = myAllPosts.filter(post => post.slug.includes(`${endPath}`));

  //   console.log("filterData",filtered);

  //   // setBodyData(filtered[0]?.body)
  //   // setSelectedHighlight(filtered[0]?.slug)

  // }, [allPosts?.length>0 && endPath]);

  // ctrl + k Keyboard =======
  const handleKeyPress = (event) => {
    // No search on Open Document pages (registered once, so read the URL
    // rather than the isOpenLink state captured at mount).
    if (window.location.pathname.split("/").filter(Boolean)[0] === "od") {
      return;
    }
    if (event.ctrlKey && event.key === "k") {
      event.preventDefault();
      setIsSearchOpen((prevVisible) => !prevVisible);
    }
  };
  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  const gettingLoginFunc = () => {
    localStorage.removeItem("cn_access_token");
    return (window.location.href = "/");
  };

  const gettingRefreshFunc = () => {
    localStorage.removeItem("cn_access_token");
    return (window.location.href = "/");
  };
  // Date: 8 Feb 2025 start
  useEffect(() => {
    const handleContextMenu = (event) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  // Disable all things :
  // useEffect(() => {
  //   const handleContextMenu = (event) => event.preventDefault();

  //   const handleKeyDown = (event) => {
  //     // Disable F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U, Ctrl+Shift+C
  //     if (
  //       event.key === "F12" ||
  //       (event.ctrlKey && event.shiftKey && ["I", "J", "C"].includes(event.key)) ||
  //       (event.ctrlKey && event.key === "U")
  //     ) {
  //       event.preventDefault();
  //     }
  //   };

  //   document.addEventListener("contextmenu", handleContextMenu);
  //   document.addEventListener("keydown", handleKeyDown);

  //   return () => {
  //     document.removeEventListener("contextmenu", handleContextMenu);
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, []);
  // Date: 8 Feb 2025 end

  // Date: 10 Sep 2026
  // Ref: Clicking a KbChooser tile / "Back to Dashboard" swaps `product`
  // (chooseProduct/switchKnowledgeBaseFunc), which re-renders this component
  // with a different Routes branch (see below) *before* the effect above has
  // run getAllPostFunc()'s setPostLoader(true) -- useEffect fires after
  // commit/paint, so that first render always painted the new product's
  // Home/MiddleHome with empty allPosts/bodyData for a frame, i.e. the
  // "no content for a moment" popup. prevProductRef.current still holds the
  // *previous* product during that render (the effect only updates it after
  // commit), so comparing against it here re-enters the loading splash for
  // that one render, before the empty content ever paints.
  const isSwitchingProduct = product !== prevProductRef.current;
  if (postLoader || loginDataLoading || isSwitchingProduct) {
    return (
      // <div className="flex items-center justify-center h-screen">Loading..</div>
      <div className="flex items-center justify-center h-screen p-4">
        <div class={`loading`}>
          <span class="letter text-cfBlue">C</span>
          <span class="letter text-cfBlue">l</span>
          <span class="letter text-cfBlue">o</span>
          <span class="letter text-cfBlue">u</span>
          <span class="letter text-cfBlue">d</span>
          <span class="letter">F</span>
          <span class="letter">r</span>
          <span class="letter">a</span>
          <span class="letter">m</span>
          <span class="letter">e</span>
        </div>
      </div>
    );
  }

  // Date: 28 Feb 2025
  const currentArticleAddrGoBackFunc = () => {
    localStorage.removeItem("cn_access_token");
    return (window.location.href = getCurrentArticleAddress);
  };
  // Date: 27 Feb 2025
  if (isArticleNotFound) {
    return (
      <div className={`h-screen p-4 flex flex-col items-center justify-center`}>
        <div>Article not found</div>
        <div
          className={`text-[14px] ${
            darkTheme ? "text-DarkGray" : "text-LightBlack"
          }`}
        >
          Go back to the home page
        </div>
        {/* <Button onClick={() => gettingRefreshFunc()} className={`!mt-4`}> */}
        <Button
          onClick={() => currentArticleAddrGoBackFunc()}
          className={`!mt-4`}
        >
          Go back
        </Button>
      </div>
    );
  }
  // Date: 27 Feb 2025
  if (isOdArticleNotFound) {
    return (
      <div className={`h-screen p-4 flex flex-col items-center justify-center`}>
        <div>Article not found</div>
        <div
          className={`text-[14px] ${
            darkTheme ? "text-DarkGray" : "text-LightBlack"
          }`}
        >
          Go back to the home page
        </div>
        <Button onClick={() => gettingRefreshFunc()} className={`!mt-4`}>
          Go back
        </Button>
      </div>
    );
  }
  // IN-OD internal 500 error HANDLER LOADER
  const odRefreshFunc = () => {
    window.location.href = "/od";
  };
  if (odPostLoaderHandler) {
    return (
      <div className={`h-screen p-4 flex flex-col items-center justify-center`}>
        <div>Internal error</div>
        <div
          className={`text-[14px] ${
            darkTheme ? "text-DarkGray" : "text-LightBlack"
          }`}
        >
          Please try again
        </div>
        <Button onClick={() => odRefreshFunc()} className={`!mt-4`}>
          Refresh
        </Button>
      </div>
    );
  }
  // internal 500 error HANDLER LOADER
  if (postLoaderHandler && accessToken) {
    return (
      <div className={`h-screen p-4 flex flex-col items-center justify-center`}>
        {/* <div>Internal error</div> */}
        {/* Date: 17 March 2025 */}
        <div>{errMsgForPostLoaderHandler}</div>
        <div
          className={`text-[14px] ${
            darkTheme ? "text-DarkGray" : "text-LightBlack"
          }`}
        >
          {/* Date: 17 March 2025 */}
          Please, refresh the page
        </div>
        <Button
          onClick={() => gettingRefreshFuncWhenSlugNull()}
          className={`!mt-4`}
        >
          Refresh
        </Button>
      </div>
    );
  }
  // Date: 17 March 2025
  const gotToFallbackVersionFunc = async () => {
    const gettingCnUserInfoData = await GetLocalStorageValue("cn_userInfo", {});
    // setCnUserInfo(gettingCnUserInfoData);
    const fallbackVersion = gettingCnUserInfoData?.platform_version;
    return (window.location.href = `/${
      fallbackVersion ? fallbackVersion : ""
    }`);
  };
  if (postLoaderHandler && cnAccessToken) {
    return (
      <div className={`h-screen p-4 flex flex-col items-center justify-center`}>
        <div className={`${darkTheme ? "text-Tomato" : "text-Tomato2"}`}>
          Version not available
        </div>
        <div
          className={`text-[14px] ${
            darkTheme ? "text-DarkGray" : "text-lighGray"
          }`}
        >
          Please, Go Back to Other Version
        </div>
        <Button onClick={() => gotToFallbackVersionFunc()} className={`!mt-4`}>
          Go to other Version
        </Button>
      </div>
    );
  }
  // error HANDLER Fail to Fetch: LOADER
  if (failedToFetchLoaderHandler) {
    return (
      <div className={`h-screen p-4 flex flex-col items-center justify-center`}>
        <div>Can't connect to the network</div>
        <div
          className={`text-[14px] ${
            darkTheme ? "text-DarkGray" : "text-lighGray"
          }`}
        >
          Please connect to the network
        </div>
        <Button onClick={() => gettingRefreshFunc()} className={`!mt-4`}>
          Refresh
        </Button>
      </div>
    );
  }

  // Date: 15 Feb 2025
  // error HANDLER article not matched: LOADER
  if (articleNotMatchedLoaderHandler) {
    return (
      <div className={`h-screen p-4 flex flex-col items-center justify-center`}>
        <div>Article Not Found</div>
        <div
          className={`text-[14px] ${
            darkTheme ? "text-DarkGray" : "text-lighGray"
          }`}
        >
          Please, Go back to the home page
        </div>
        {/* <Button onClick={() => gettingRefreshFunc()} className={`!mt-4`}> */}
        <Button
          onClick={() => currentArticleAddrGoBackFunc()}
          className={`!mt-4`}
        >
          Go back
        </Button>
      </div>
    );
  }
  // OD error HANDLER Fail to Fetch: LOADER
  const gettingOdRefreshFunc = () => {
    window.location.href = "/od";
  };
  if (odFailedToFetchLoaderHandler) {
    return (
      <div className={`h-screen p-4 flex flex-col items-center justify-center`}>
        <div>Can't connect to the network</div>
        <div
          className={`text-[14px] ${
            darkTheme ? "text-DarkGray" : "text-lighGray"
          }`}
        >
          Please connect to the network
        </div>
        <Button onClick={() => gettingOdRefreshFunc()} className={`!mt-4`}>
          Refresh
        </Button>
      </div>
    );
  }

  // OD LOADER
  if (odLoader) {
    return (
      <div className={`h-screen p-4 flex flex-col items-center justify-center`}>
        <div className={`${darkTheme ? "text-Tomato" : "text-Tomato2"}`}>
          Data not available in the selected version
        </div>
        <div
          className={`text-[14px] ${
            darkTheme ? "text-DarkGray" : "text-lighGray"
          }`}
        >
          Please Login
        </div>
        <Button onClick={() => gettingLoginFunc()} className={`!mt-4`}>
          Login
        </Button>
      </div>
    );
  }
  // empty post LOADER
  const gettingHomePageWithRemoveCNtoken = () => {
    localStorage.removeItem("cn_access_token");
    return (window.location.href = "/");
  };
  if (emptyPostLoader) {
    return (
      <div className={`h-screen p-4 flex flex-col items-center justify-center`}>
        <div className={`${darkTheme ? "text-Tomato" : "text-Tomato2"}`}>
          Data not available in the selected version
        </div>
        <div
          className={`text-[14px] ${
            darkTheme ? "text-DarkGray" : "text-lighGray"
          }`}
        >
          Please go to home page
        </div>
        <Button
          onClick={() => gettingHomePageWithRemoveCNtoken()}
          className={`!mt-4`}
        >
          Home
        </Button>
      </div>
    );
  }

  // // heading count using DOMparser
  // const parseHTMLAndCountHeadings = (dataArray) => {
  //   return dataArray.map((user) => {
  //     // Map through each user's posts
  //     const updatedPosts = user.posts.map((post) => {
  //       const parser = new DOMParser();
  //       const doc = parser.parseFromString(post.body, "text/html");

  //       // Count all headings h1, h2, h3, and h4
  //       const count = {
  //         h1: doc.getElementsByTagName("h1").length,
  //         h2: doc.getElementsByTagName("h2").length,
  //         h3: doc.getElementsByTagName("h3").length,
  //         h4: doc.getElementsByTagName("h4").length,
  //       };

  //       // Return a new post object with the count key added
  //       return {
  //         ...post,
  //         count,
  //       };
  //     });

  //     // Return a new user object with the updated posts
  //     return {
  //       ...user,
  //       posts: updatedPosts,
  //     };
  //   });
  // };

  // const newUpdatedData = parseHTMLAndCountHeadings(allPosts);

  // console.log("new",newUpdatedData);
  // console.log("old",allPosts);

  return (
    // <div className="max-w-[1440px] mx-auto relative">
    <div className="relative" data-product={productSlug(product)}>
      <GlobalStyle darkTheme={darkTheme} />

      <div className="max-w-[1740px] mx-auto ">
        {/* START PROFILE MSAL AUTH  */}

        {/* <AuthenticatedTemplate>
          <ProfileContent />
        </AuthenticatedTemplate>

        <UnauthenticatedTemplate>
          <h5 className="card-title">
            Please sign-in to see your profile information.
          </h5>
        </UnauthenticatedTemplate> */}

        {isMsalLogin ? (
          <>
            {/* <Router> */}
            <Routes>
              <Route
                path="/authentication"
                element={
                  <AuthenticatedTemplate>
                    <ProfileContent />
                  </AuthenticatedTemplate>
                }
              />

              <Route
                path="/"
                element={
                  <>
                    {/* Date: 11 Sep 2026
                        Ref: A redirect-based MS login lands back on "/" (not
                        "/authentication") after the full-page round trip, so
                        this route has to complete the login itself instead
                        of relying on something else navigating away first --
                        that navigation was previously only wired up for the
                        popup flow. */}
                    <AuthenticatedTemplate>
                      <ProfileContent />
                    </AuthenticatedTemplate>
                    <UnauthenticatedTemplate>
                      {/* <h5 className="card-title">
                          Please sign-in to see your profile information.
                        </h5> */}
                      <Login />
                    </UnauthenticatedTemplate>
                  </>
                }
              />
            </Routes>
            {/* </Router> */}
          </>
        ) : (
          <>
            {/* <Router> */}
            {/* <Layout /> */}

            <Routes>
              {/* login with cn - with - slug */}
              {codeNavigatorSlugLogin === false ? (
                <>
                  {isOpenLink ? (
                    <>
                      <Route path="/" element={<Layout />}>
                        <Route path="/*" element={<Home />} />
                        <Route index element={<Home />} />
                        {/* <Route
                      path="/od/page-not-found"
                      element={<OdPageNotFound />}
                    /> */}
                      </Route>
                    </>
                  ) : (
                    <>
                      {codeNavigatorToken !== "" || resToken !== "" ? (
                        tokenMode === "personal" && !product ? (
                          <>
                            <Route path="/cloudframe" element={<KbChooser />} />
                            <Route
                              path="/*"
                              element={<Navigate to="/cloudframe" replace />}
                            />
                          </>
                        ) : tokenMode === "personal" && product === "continuum" ? (
                          // Continuum now reads real backend content via the same
                          // Layout/Home reader used by CodeNavigator (see
                          // getAllPostFunc, which fetches personal/posts?product=continuum),
                          // mounted under its own launch prefix the same way CodeNavigator is below.
                          <>
                            <Route
                              path="/cloudframe/continuum"
                              element={<Layout />}
                            >
                              <Route path="*" element={<Home />} />
                              <Route index element={<Home />} />
                            </Route>
                            <Route
                              path="/*"
                              element={
                                <Navigate to="/cloudframe/continuum" replace />
                              }
                            />
                          </>
                        ) : tokenMode === "personal" &&
                          product === "codeNavigator" ? (
                          // Date: 7 Aug 2026
                          // Ref: Continuum KB rollout. Mounting Home under the
                          // literal "/cloudframe/codenavigator" route (instead of
                          // "/") keeps that prefix on every relative navigate()
                          // Home fires internally (e.g. to a post's version/slug
                          // URL) -- React Router resolves those against the
                          // route's own path, not the raw browser URL, so
                          // without this the prefix was getting dropped as soon
                          // as the first post loaded.
                          <>
                            <Route
                              path="/cloudframe/codenavigator"
                              element={<Layout />}
                            >
                              <Route path="*" element={<Home />} />
                              <Route index element={<Home />} />
                            </Route>
                            <Route
                              path="/*"
                              element={
                                <Navigate to="/cloudframe/codenavigator" replace />
                              }
                            />
                          </>
                        ) : (
                          <Route path="/" element={<Layout />}>
                            <Route path="/*" element={<Home />} />
                            <Route index element={<Home />} />
                          </Route>
                        )
                      ) : (
                        <>
                          <Route path="/" element={<Login />} />
                          <Route path="/*" element={<PageNotFound />} />
                        </>
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  <Route
                    // path={endPath ? `/${endPath}/auth` : "/auth"}
                    // path={endPath ? `/${endPath}` : "/auth"}
                    path={`/${endPath}`}
                    element={<Callback />}
                  />
                </>
              )}
              <>
                <Route path={"/auth"} element={<Callback />} />
                {/* Date: 21 Jan 2025  */}
                <Route
                  path={"/version_not_available_with_cn"}
                  element={<CnVersionNotAvailable />}
                />
                {/* Date: 27 Feb 2025  */}
                <Route
                  path="/article-not-available"
                  element={<ArticleNotAvailable />}
                />
              </>
            </Routes>
            {/* </Router> */}
          </>
        )}

        {/* END PROFILE MSAL AUTH  */}
      </div>
    </div>
  );
}
